import { Link } from "react-router-dom";
import styled from "styled-components";
import { TextField as TextFieldMUI } from "@mui/material";
import materialUI from "../../../../material-UI";

export const Container = styled.div`
  width: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  padding: 0 8px;
`;

export const Title = styled.h1`
  color: #4361ee;
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ContactCount = styled.div`
  text-align: right;
  font-size: 14px;
  padding: 0 8px;
  span {
    font-weight: 600;
  }
`;

export const ContactCountText = styled.p`
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: right;
`;

export const ContactInfoText = styled.p`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: right;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 16px;
  background: transparent;
`;

export const Th = styled.th`
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  vertical-align: middle;
  padding: 20px 16px;
  text-align: left;
  background: #f8f9fa;
  color: #000000de;
  &:first-child {
    padding-left: 24px;
    border-radius: 8px 0 0 8px;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 2px;
  background: #2d5bff;
`;

export const Td = styled.td`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  padding: 22px 16px;
  background: white;
  color: #101828;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;

  &:first-child {
    padding-left: 24px;
    border-radius: 8px 0 0 8px;
    border-left: 1px solid #e0e0e0;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
    border-right: 1px solid #e0e0e0;
  }
  tr:hover & {
    background: #f8f9fa;
  }
`;

export const ProjectImage = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  background: #f8f9fa;
`;

export const ProjectCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ProjectName = styled.p`
  max-width: 150px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Status = styled.span`
  color: #0091ff;
  font-weight: 500;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:first-child {
    color: #2d5bff;
  }
  &:last-child {
    color: #ff4d4d;
  }
  &:hover {
    opacity: 0.8;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ActionsCell = styled.div`
  display: flex;
  gap: 8px;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 0 12px 0;
`;

export const NewCampaignButton = styled(Link)`
  text-decoration: none;
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: center;
  width: 100%;
  padding: 16px;
  background: linear-gradient(90deg, #4361ee 0%, #06d986 100%);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  margin-top: 24px;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
`;

export const RelatorioSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 0;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Space: any = styled.div`
  min-height: ${(props: any) => props.space}px;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px;
`;

export const GerarRelatorioButton = styled.button`
  box-sizing: border-box;

  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  height: 40px;
  width: 100%;
  margin-top: 28px;
  background: #ffffff;

  color: #4caf50;
  border: 1px solid #4caf50;
  border-radius: 8px;
  cursor: ${(props: any) => (props.disabled ? "not-allowed" : "pointer")};

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;
